import {
  EtxeApiPrefixes,
  ListPagination,
  PropertyDto,
  PropertyId,
  PropertyOwnerSummaryDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils';

export class PropertiesAgentConnector extends ApiConnector<PropertyDto, PropertyDto, PropertyId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string, parentSlug: string) {
    super(apiCaller, apiPrefix, `${parentSlug}/agent`);
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<PropertyDto[]> =>
      this.apiCaller.getRequest<PropertyDto[]>(
        EtxeApiPrefixes.CORE,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        EtxeApiPrefixes.CORE,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });

  explore = () => ({
    list: (pagination?: ListPagination, city?: string): Observable<PropertyDto[]> => {
      const params = QueryParamsUtils.buildFilterParams(pagination);
      const sep = params.includes('?') ? '&' : '?';
      const cityQuery = city && city.trim() ? `${sep}city=${encodeURIComponent(city.trim())}` : '';
      return this.apiCaller.getRequest<PropertyDto[]>(
        EtxeApiPrefixes.CORE,
        `${this.slug}/explore${params}${cityQuery}`,
      );
    },
    count: (pagination?: ListPagination, city?: string): Observable<number> => {
      const params = QueryParamsUtils.buildFilterParams(pagination, true);
      const sep = params.includes('?') ? '&' : '?';
      const cityQuery = city && city.trim() ? `${sep}city=${encodeURIComponent(city.trim())}` : '';
      return this.apiCaller.getRequest<number>(
        EtxeApiPrefixes.CORE,
        `${this.slug}/explore/count${params}${cityQuery}`,
      );
    },
  });

  owner = (propertyId: PropertyId): Observable<PropertyOwnerSummaryDto> =>
    this.apiCaller.getRequest<PropertyOwnerSummaryDto>(
      EtxeApiPrefixes.CORE,
      `${this.slug}/${propertyId}/owner`,
    );
}
